<script setup lang="ts">
const store = useStore()
const { modal } = storeToRefs(store)
</script>

<template>
  <Teleport to='body'>
    <div v-if="modal.type" class="fixed top-0 left-0 w-full h-[calc(100%-52px)] bg-white overflow-auto z-10 lg:hidden">
      <div class="flex justify-between items-center p-[15px] border-b border-solid border-gray-400">
        <h2 class="text-24 font-bold">
          {{ modal.name }}
        </h2>
        <i class="icon-close" @click="store.getModal(false, null)" />
      </div>
      <slot />
    </div>
  </Teleport>
</template>
